import api from './api';

export const artikelService = {
    // Get all articles
    getArtikels: async (params = {}) => {
        try {
            const response = await api.get('/artikels', { params });
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengambil data artikel'
            };
        }
    },

    // Get single article
    getArtikel: async (id) => {
        try {
            const response = await api.get(`/artikels/${id}`);
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengambil data artikel'
            };
        }
    },

    // Create article
    createArtikel: async (data) => {
        try {
            const response = await api.post('/artikels', data);
            return { success: true, data: response.data, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal membuat artikel'
            };
        }
    },

    // Update article
    updateArtikel: async (id, data) => {
        try {
            const response = await api.put(`/artikels/${id}`, data);
            return { success: true, data: response.data, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengupdate artikel'
            };
        }
    },

    // Delete article
    deleteArtikel: async (id) => {
        try {
            const response = await api.delete(`/artikels/${id}`);
            return { success: true, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal menghapus artikel'
            };
        }
    },

    // Submit for review
    submitArtikel: async (id) => {
        try {
            const response = await api.post(`/artikels/${id}/submit`);
            return { success: true, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal submit artikel'
            };
        }
    },

    // Review article
    reviewArtikel: async (id, action, catatan) => {
        try {
            const response = await api.post(`/artikels/${id}/review`, { action, catatan });
            return { success: true, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal review artikel'
            };
        }
    },

    // Approve article
    approveArtikel: async (id, action, catatan) => {
        try {
            const response = await api.post(`/artikels/${id}/approve`, { action, catatan });
            return { success: true, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal approve artikel'
            };
        }
    },

    // Publish article
    publishArtikel: async (id) => {
        try {
            const response = await api.post(`/artikels/${id}/publish`);
            return { success: true, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal publish artikel'
            };
        }
    },

    // Unpublish article
    unpublishArtikel: async (id) => {
        try {
            const response = await api.post(`/artikels/${id}/unpublish`);
            return { success: true, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal unpublish artikel'
            };
        }
    },

    // Create dengan multipart
    createArtikel: async (formData) => {
        try {
            const response = await api.post('/artikels', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return { success: true, data: response.data, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal membuat artikel'
            };
        }
    },

    // Update dengan multipart
    updateArtikel: async (id, formData) => {
        try {
            // Gunakan POST + _method=PUT untuk multipart
            formData.append('_method', 'PUT');
            const response = await api.post(`/artikels/${id}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return { success: true, data: response.data, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengupdate artikel'
            };
        }
    },

    // Upload image untuk editor WYSIWYG
    uploadEditorImage: async (formData) => {
        try {
            const response = await api.post('/artikels/upload-image', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal upload gambar'
            };
        }
    },

    unarchiveArtikel: async (id) => {
        try {
            const response = await api.post(`/artikels/${id}/unarchive`);
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengembalikan artikel',
            };
        }
    },

    // Get statistics
    getStatistics: async () => {
        try {
            const response = await api.get('/artikel-statistics');
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengambil statistik'
            };
        }
    }
};